export const exportToCSV = (localData, sourceName, headers, fields) => {
    const csvRows = [
        headers.join(","),
        ...localData.map((r) => {
            return fields.map((f) => {
                const val = r[f] !== null && r[f] !== undefined ? r[f] : "";
                const strVal = String(val).replace(/"/g, '""');
                return strVal.includes(",") || strVal.includes("\n") || strVal.includes('"') ? `"${strVal}"` : strVal;
            }).join(",");
        })
    ];

    const blob = new Blob([csvRows.join("\n")], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.setAttribute("href", url);
    const dateStr = new Date().toISOString().split('T')[0];
    link.setAttribute("download", `${sourceName.toLowerCase()}_explorer_export_${dateStr}.csv`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
};
